// extracted by mini-css-extract-plugin
export var backupIcon = "_td-1";
export var image = "_td-0";